import { InterviewLayout, InterviewModality } from '@/types/pulse';

/**
 * The pairing between the guided layout and the ALL modality: guided runs no
 * other modality, and ALL runs under no other layout. Both directions of the
 * pairing are read from here, so no form, resolver or picker restates it.
 */

/** The modality a layout pins, or undefined when the layout runs any modality. */
export function modalityPinnedByLayout(
  layout: InterviewLayout | string | undefined
): InterviewModality | undefined {
  return layout === InterviewLayout.GUIDED ? InterviewModality.ALL : undefined;
}

/** The layout a modality requires, or undefined when it runs under any layout. */
export function layoutRequiredByModality(
  modality: InterviewModality | undefined
): InterviewLayout | undefined {
  return modality === InterviewModality.ALL
    ? InterviewLayout.GUIDED
    : undefined;
}
